import React from "react"
import {useLocation, useNavigate} from "react-router-dom"
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import SeasonTab from "./SeasonTab"
import TotalTab from "./TotalTab"
import RescuesTab from "./RescuesTab"
import "./AnalyticsPage.css"


export default function AnalyticsPage() {

    const location = useLocation()
    const navigate = useNavigate()
    const tab = location.hash.slice(1) || "seasons"
    const setTab = (key) => navigate({hash: key}, {replace: true})

    return <div id="analytics">
        <Tabs activeKey={tab} onSelect={setTab} transition={false}>
            <Tab eventKey="seasons" title="Sezone">
                {tab === "seasons" && <SeasonTab/>}
            </Tab>
            <Tab eventKey="total" title="Ukupno">
                {tab === "total" && <TotalTab/>}
            </Tab>
            <Tab eventKey="rescues" title="Povrede">
                {tab === "rescues" && <RescuesTab/>}
            </Tab>
        </Tabs>
    </div>
}
